var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex-align-center d-flex-column custom-box" },
    [
      _c("span", { staticClass: "custom-subtitle" }, [
        _vm._v(
          " " +
            _vm._s(
              !_vm.secondCard
                ? _vm.$t("consignee.pickup_management.last_declaration")
                : _vm.askingDeclaration
                ? _vm.$t("consignee.pickup_management.waiting_for_inv")
                : _vm.$t("consignee.pickup_management.question_want_to_declare")
            ) +
            " "
        ),
      ]),
      _c(
        "div",
        { staticClass: "d-flex-row d-flex-justify-center d-flex-space-around" },
        [
          !_vm.mail.spontaneous && !_vm.secondCard
            ? _c(
                "div",
                [
                  _c(
                    "b-taglist",
                    { attrs: { attached: "" } },
                    [
                      _c(
                        "b-tag",
                        { attrs: { size: "is-medium", type: "is-dark" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("consignee.pickup_management.received")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "b-tag",
                        { attrs: { size: "is-medium", type: "is-info" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm
                                  .$dayjs(_vm.mail.firstSendingDate)
                                  .local()
                                  .format("DD/MM/YYYY HH:mm")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.secondCard
            ? _c(
                "div",
                [
                  _c(
                    "b-taglist",
                    { attrs: { attached: "" } },
                    [
                      _c(
                        "b-tag",
                        { attrs: { size: "is-medium", type: "is-dark" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("consignee.pickup_management.declared")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "b-tag",
                        {
                          attrs: {
                            size: "is-medium",
                            type: _vm.mail.declarationId
                              ? "is-info"
                              : "is-danger",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm
                                  .$dayjs(_vm.mail.declarationDate)
                                  .local()
                                  .format("DD/MM/YYYY HH:mm")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm.askingDeclaration
                    ? _c(
                        "div",
                        { staticClass: "has-text-centered" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "exclamation-triangle",
                              type: "is-warning",
                              size: "is-large",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-button",
                    {
                      staticClass: "is-medium",
                      attrs: { type: "is-outlined is-info" },
                      on: { click: _vm.spontaneousDeclaration },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "consignee.pickup_management.make_declaration"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
        ]
      ),
      !_vm.secondCard
        ? _c(
            "b-button",
            {
              staticClass: "is-small button",
              attrs: { "icon-left": "barcode", type: "is-primary is-outlined" },
              on: {
                click: function ($event) {
                  return _vm.$emit("see-declaration", _vm.mail)
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("consignee.pickup_management.see_declaration")
                  ) +
                  " "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }